import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/closeb.png';
import _imports_1 from '../../assets/image/search.png';
import _imports_2 from '../../assets/image/sehar.png';
const _withScopeId = n => (_pushScopeId("data-v-0fdeec6e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tk-header-box"
};
const _hoisted_2 = {
  key: 0,
  class: "appdownload"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "desc"
};
const _hoisted_5 = {
  class: "down"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = {
  class: "tk-header flex-between"
};
const _hoisted_8 = {
  class: "tk-header-logo"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "tk-header-info"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_12 = [_hoisted_11];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_14 = [_hoisted_13];
import { onBeforeMount } from "vue";

import { useRouter, useRoute } from 'vue-router';
import { ref, reactive, onMounted } from 'vue';
export default {
  __name: 'header',
  props: {
    headLogo: "",
    config: {}
  },
  emits: ["serach", "sehar", "colse"],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const router = useRouter();
    const route = useRoute();
    let websiteName = ref(process.env.VUE_APP_BASE_API_S);
    let serach = () => {
      emits("serach");
      router.push({
        path: `/serach`
      });
    };
    let sehar = () => {
      emits("sehar");
    };
    let getQueryString = name => {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    };
    let tipsData = reactive({
      //弹窗提示
      downloadapp: true
    });
    onBeforeMount(() => {
      if (getQueryString("down") == "false") {
        tipsData.downloadapp = "false";
        localStorage.setItem("down", false);
        // tipsData.downloadapp = localStorage.getItem('downloadapp')==null?'false':localStorage.getItem('downloadapp');//判断是否显示
      } else {
        if (localStorage.getItem("down") == null) {
          tipsData.downloadapp = true;
        } else {
          tipsData.downloadapp = "false";
        }
      }
      if (getQueryString("showDown") != null) {
        localStorage.setItem("showDown", false);
        tipsData.downloadapp = localStorage.getItem("showDown") == null ? "false" : localStorage.getItem("showDown"); //判断是否显示
      } else {
        tipsData.downloadapp = true;
      }
    });
    let colse = () => {
      //关闭app下载
      localStorage.setItem("downloadapp", false);
      emits("colse");
      tipsData.downloadapp = "false";
    };
    const showTipsbs = ref(true);
    onMounted(async () => {
      if (localStorage.getItem("showDown") || route.query.showDown) {
        showTipsbs.value = true;
      } else {
        showTipsbs.value = false;
      }
      if (localStorage.getItem("label") || route.query.label) {
        showTipsbs.value = false;
      } else {
        showTipsbs.value = true;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_unref(tipsData).downloadapp != 'false' && _unref(showTipsbs) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
        class: "logo",
        src: _unref(websiteName) + __props.config.logo,
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, "下载" + _toDisplayString(__props.config.name) + "，看图更爽", 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("a", {
        href: __props.config.download_url
      }, "下载", 8, _hoisted_6)]), _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(colse) && _unref(colse)(...args))
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
        src: _unref(websiteName) + __props.headLogo,
        alt: ""
      }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
        class: "tk-serach",
        onClick: _cache[1] || (_cache[1] = (...args) => _unref(serach) && _unref(serach)(...args))
      }, _hoisted_12), _createElementVNode("div", {
        class: "tk-sehar",
        onClick: _cache[2] || (_cache[2] = (...args) => _unref(sehar) && _unref(sehar)(...args))
      }, _hoisted_14)])])]), _createElementVNode("div", {
        class: _normalizeClass(_unref(tipsData).downloadapp != 'false' && _unref(showTipsbs) ? 'headers' : 'headerbb')
      }, null, 2)], 64);
    };
  }
};